import React, {useState, useEffect} from 'react';
//API
import VideosRepository from 'client-sdk/src/Repository/videos-repository';

//components
import VideoCarousel from './components/videoCarousel';
import VideoStepper from './components/videoStepper';
import VideoCard from './components/videoCard';
import {Typography, Paper, Grid} from '@material-ui/core';

//style
import {StylesProvider} from '@material-ui/core/styles';
import classes from './index.module.css';
//utils
import {translateVideosName} from '../../utils/helpers';
const Videos = () => {
  // states
  const [videos, setVideos] = useState({});
  const [video, setVideo] = useState([]);

  //requests
  const getVideos = async () => {
    const {response, pagination} = await VideosRepository.getVideos({
      payload: {pagination: ''},
    });
    setVideos(response.data.result);
  };
  const updateVideo = async (id: number) => {
    await VideosRepository.updateVideoStatus({
      payload: {id},
    });
    await getVideos();
  };

  // handlers
  const clickThumbHandler = (item: any) => {
    if (item.seenStatus == 'NOT_SEEN') {
      updateVideo(item.id);
    }
  };

  const selectCategoryHandler = (videoObj: any) => {
    setVideo(videoObj);
    clickThumbHandler(videoObj[1].videos[0]);
  };

  // effects
  useEffect(() => {
    getVideos();
  }, []);

  //JSX
  return (
    <StylesProvider injectFirst>
      <Typography variant="h6" component="h1">
        {`ویدیوهای آموزشی`}
      </Typography>
      <Paper className={classes.paper}>
        <Grid xs={12}>
          <VideoStepper
            selectCategoryHandler={selectCategoryHandler}
            steps={videos}
          />
        </Grid>
        <Typography className={classes.topic}>{'لیست ویدیو‌ها'}</Typography>
        <Paper className={classes.cardContainer}>
          <Grid xs={12} spacing={3} container>
            {Object.entries(videos).map((videoObj, index) => {
              return (
                <Grid key={index} item xs={3}>
                  <VideoCard
                    selectCategoryHandler={selectCategoryHandler}
                    videoObj={videoObj}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Paper>
        {video[0] && (
          <>
            {' '}
            <Typography className={classes.topic}>
              {'ویدیو'}
              &nbsp;
              {translateVideosName(video[0])}
            </Typography>
            <Grid xs={12} style={{marginTop: '30px'}}>
              <VideoCarousel
                video={video}
                clickThumbHandler={clickThumbHandler}
              />
            </Grid>
          </>
        )}
      </Paper>
    </StylesProvider>
  );
};

export default Videos;
